import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import * as React from "react";
import * as ReactDOM from "react-dom";
import configureStore from "./store/configureStore";
import Root from "./pages/Root";

const store = configureStore();

ReactDOM.render(<Root store={store} />, document.querySelector("#root"));
